import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[hover-class]'
})
export class HoverClassDirective {

    constructor(public elementRef: ElementRef) {
    }

    @Input('hover-class') hoverClass: any;

    @HostListener('mouseenter') onMouseEnter() {
        this.update('add');
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.update('remove');
    }

    protected update(action: string): void {
        this.hoverClass.split(' ').forEach(item => this.elementRef.nativeElement.classList[action](item));
    }
}
